(() => {
  const connect = () => {
    document.querySelectorAll('product-info.sd-refined-product').forEach(root => {
      if (root.dataset.sdPurchaseConnected) return;
      root.dataset.sdPurchaseConnected = 'true';
      const bar = root.querySelector('[data-sd-purchase]');
      if (!bar) return;
      const button = bar.querySelector('[data-sd-purchase-button]');
      const update = () => {
        const native = root.querySelector('.product-form__submit');
        if (!native) { bar.hidden = true; return; }
        bar.hidden = false;
        button.disabled = native.disabled;
        const label = native.querySelector('span')?.textContent.trim() || native.textContent.trim();
        const priceRoot = root.querySelector('[id^="price-"]');
        const onSale = priceRoot?.querySelector('.price--on-sale');
        const price = (onSale ? onSale.querySelector('.price-item--sale') : priceRoot?.querySelector('.price__regular .price-item--regular'))?.textContent.trim() || '';
        const labelNode = bar.querySelector('[data-sd-purchase-label]');
        const priceNode = bar.querySelector('[data-sd-purchase-price]');
        if (labelNode.textContent !== label) labelNode.textContent = label;
        if (priceNode.textContent !== price) priceNode.textContent = price;
        priceNode.hidden = button.disabled || !price;
      };
      update();
      new MutationObserver(records => {
        if (records.some(record => !bar.contains(record.target))) update();
      }).observe(root, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','class']});
    });
  };
  connect();
  document.addEventListener('shopify:section:load', connect);
})();
